import request from "@/utils/request";
// 保证金列表
export function bondList(params) {
  return request({
    url: "delivery/bond/index",
    method: "get",
    params,
  });
}
// 保证金操作
export function bondOperation(data) {
  return request({
    url: "delivery/bond/bond-operate",
    method: "post",
    data,
  });
}
// 培训列表
export function trainList(params) {
  return request({
    url: "delivery/train/index",
    method: "get",
    params,
  });
}
// 培训地址保存
export function trainSave(data) {
  return request({
    url: "delivery/train/save",
    method: "post",
    data,
  });
}
// 培训地址保存
export function trainInfo(params) {
  return request({
    url: "delivery/train/save",
    method: "get",
    params,
  });
}
//删除培训地址
export function trainDelete(data) {
  return request({
    url: "delivery/train/operate",
    method: "post",
    data,
  });
}
// 预约列表
export function appointmentList(params) {
  return request({
    url: "delivery/train/subscribe-list",
    method: "get",
    params,
  });
}
// 学习列表
export function learningList(params) {
  return request({
    url: "delivery/college/study-list",
    method: "get",
    params,
  });
}
// 学习内容信息
export function learningInfo(params) {
  return request({
    url: "delivery/college/list-save",
    method: "get",
    params,
  });
}
// 添加学习内容
export function learningSave(data) {
  return request({
    url: "delivery/college/list-save",
    method: "post",
    data,
  });
}
// 删除学习内容
export function learningDelete(data) {
  return request({
    url: "delivery/college/list-delete",
    method: "post",
    data,
  });
}
// 分类列表
export function typeList(params) {
  return request({
    url: "delivery/college/get-category",
    method: "get",
    params,
  });
}
// 添加分类
export function typeSave(data) {
  return request({
    url: "delivery/college/save-category",
    method: "post",
    data,
  });
}
// 删除分类
export function typeDelete(data) {
  return request({
    url: "delivery/college/del-category",
    method: "post",
    data,
  });
}
// 题目列表
export function collegeList(params) {
  return request({
    url: "delivery/college/index",
    method: "get",
    params,
  });
}
// 添加题目
export function collegeSave(data) {
  return request({
    url: "delivery/college/topic-save",
    method: "post",
    data,
  });
}
// 删除题目
export function collegeDelete(data) {
  return request({
    url: "delivery/college/del-topic",
    method: "post",
    data,
  });
}
// 删除题目
export function getTextList(params) {
  return request({
    url: "delivery/college/join-list",
    method: "get",
    params,
  });
}
//题目信息
export function collegeInfo(params) {
  return request({
    url: "delivery/college/topic-save",
    method: "get",
    params,
  });
}
//预约操作
export function appointmentOperate(data) {
  return request({
    url: "delivery/train/subscribe-operate",
    method: "post",
    data,
  });
}
//考试详情
export function collegeDetail(params) {
  return request({
    url: "delivery/college/study-test",
    method: "get",
    params,
  });
}
//排名榜
export function rankingList(params) {
  return request({
    url: "delivery/bond/ranking-list",
    method: "get",
    params,
  });
}
//获取app设置详情
export function getAppSetInfo(params) {
  return request({
    url: "delivery/config/app-set",
    method: "get",
    params,
  });
}
// 获取活动列表
export function getActiveList(params) {
  return request({
    url: "delivery/activity/index",
    method: "get",
    params,
  });
}
// 添加活动
export function addActive(data) {
  return request({
    url: "delivery/activity/save",
    method: "POST",
    data,
  });
}
// 查看活动详情
export function getActiveInfo(params) {
  return request({
    url: "delivery/activity/save",
    method: "get",
    params,
  });
}
// 查看活动详情
export function removeActive(data) {
  return request({
    url: "delivery/activity/delete",
    method: "post",
    data,
  });
}
export function getJoinList(params) {
  return request({
    url: "delivery/activity/enroll-list",
    method: "get",
    params,
  });
}

//权限  
export function getPower(params) {
  return request({
    url: "delivery/config/get-super-power",
    method: "get",
    params,
  });
}

// 用户列表
export function getUser(params) {
  return request({
    url: 'delivery/cloud/user-list',
    method: 'get',
    params
  })
}
